export const TSCategoryToColor = {
	"TD": "#0099FF",
	"TS": "#81C056",
	"H1": "#F6C445",
	"H2": "#EE7932",
	"H3": "#D64A27",
	"H4": "#AC32F6",
	"H5": "#D535A9"
}

export const TSCategoryToWindSpeed = {
	"TD": [0,33],
	"TS": [34,63],
	"H1": [64,82],
	"H2": [83,95],
	"H3": [96,113],
	"H4": [114,135],
	"H5": [136,999]
}